import { BaseItem } from '../../VirtualizedTable.types';

export interface TreeNodeMeta {
  depth: number;
  trunkContinuations: boolean[];
}

const useTreeStructure = <T extends BaseItem>(items: T[]): Map<string, TreeNodeMeta> => {
  const depthMap = new Map<string, number>();
  items.forEach((item) => {
    depthMap.set(item.id, item.parentId ? (depthMap.get(item.parentId) ?? 0) + 1 : 0);
  });

  const lastChildIds = new Set<string>();
  const seenParentIds = new Set<string>();
  for (let i = items.length - 1; i >= 0; i--) {
    const { id, parentId } = items[i];
    if (parentId && !seenParentIds.has(parentId)) {
      lastChildIds.add(id);
      seenParentIds.add(parentId);
    }
  }

  const result = new Map<string, TreeNodeMeta>();
  const continuationStack: boolean[] = [];

  items.forEach((item) => {
    const depth = depthMap.get(item.id) ?? 0;
    continuationStack.length = depth;
    const trunkContinuations = continuationStack.slice(1);
    if (item.parentId) {
      continuationStack[depth] = !lastChildIds.has(item.id);
    }
    result.set(item.id, { depth, trunkContinuations });
  });

  return result;
};

export default useTreeStructure;
